require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./die-heizung-im-fussboden.json") })
        }
      }, "path---die-heizung-im-fussboden");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---die-heizung-im-fussboden!./.cache/json/die-heizung-im-fussboden.json
// module id = 417
// module chunks = 231608221292675